import { Component, HostListener, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '../app.service'
import { AlphaService } from 'src/app/app-business-object-module/alpha.service';
import { APP_Constants } from '../app.constant';
import { environment } from '../../environments/environment';
import { ModalComponent } from '../common/modal/modal.component';
import { ModalConfig } from '../common/modal/modal.config';
import { Modal } from '../common/modal/modal';
import { Subject } from 'rxjs';
import { CommonConfig } from '../common/configuration/common.config';
import { MenuItems } from '../app-nav-bar/menuItems.service';
import { CookieService } from "ngx-cookie-service";

@Component({
    selector: 'app-login',
    templateUrl: './app-login.component.html',
    styleUrls: ['./app-login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppLoginComponent implements OnInit {
  color: String = 'primary';
  mode: String = 'indeterminate';
  isLoading: boolean = false;
  errorMessage: String = '';
  isLoggedIn = 'false';
  preferredUOM;
  userAcessDataRest;
  parameterValue;
  // public userExist: boolean = true;
  SSO: boolean = true;
  isUserIdle: boolean = false;

  loginForm = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required]
  })

  userActivity;
  userInactive: Subject<any> = new Subject();

  constructor(public menuItems: MenuItems, private fb: UntypedFormBuilder, private router: Router, private appService: AppService,
  public cookieService: CookieService, private alphaService:AlphaService) { 
  /*this.setTimeout();
    this.userInactive.subscribe(() => {
      console.log('user has been inactive for 1o minutes');
      this.isUserIdle = true;
    });*/
  }


  /*setTimeout() {
    this.userActivity = setTimeout(() => {
      this.userInactive.next(undefined)
    }, 10 * 60 * 1000);
  }

  @HostListener('window:mousemove') refreshUserState1() {
    this.isUserIdle = false;
    clearTimeout(this.userActivity);
    this.setTimeout();
  }
  @HostListener('window:keypress') refreshUserState2() {
    this.isUserIdle = false;
    clearTimeout(this.userActivity);
    this.setTimeout();
  }*/

  get f() { return this.loginForm.controls; }

  user: any;
  normalView() {
    if(document.getElementById("overlay")) {
      document.getElementById("overlay").style.display = "none";
    }
  }
  
  ngOnInit() {  
    let isCookieConsentSet = this.cookieService.get('setConsent');
    let logoutMode: boolean = false;
    logoutMode = sessionStorage.getItem('logoutMode') == 'YES'? true: false;
    sessionStorage.clear();     // remove last session details
    localStorage.clear();     // remove last session details
    this.cookieService.delete('id_token');
    this.cookieService.delete('authToken');
     // NCP-15230-start If cookie consent already accpeted by user then it won't ask again until user manually delete it from Cookie
    if(isCookieConsentSet === "true") {
      this.cookieService.set('setConsent', "true");
    }
    if(environment.isSingleSignOn && logoutMode !== true){
      logoutMode = false;
	  if(this.cookieService.get('id_token') === null || this.cookieService.get('id_token') === undefined || this.cookieService.get('id_token') === '') {
        this.fetchAccessToken();
      } else {
        let tokenDetails = this.appService.getDecodedAccessToken(this.cookieService.get('id_token'));
        //console.log(tokenDetails);
        if(tokenDetails){
          let currentTimestamp = Math.floor(Date.now() / 1000);
          if(tokenDetails.exp > currentTimestamp){
            // userId = tokenDetails.unique_name;
            let userId = '';
            if(tokenDetails.email){
              userId=tokenDetails.email;
            }else if(tokenDetails.upn){
              userId = tokenDetails.upn;
            }else if(tokenDetails.unique_name){
              userId = tokenDetails.unique_name;
            }
            this.ssoLogin(userId);

      } else {
            this.appService.initiateAzureLogin();
          }
	}
      }
    }
  }

  submitted: boolean = false;

  ssoLogin(username) {
    if (username) {
      this.isLoading = true;
      this.appService.makeHttpGetRequest(APP_Constants.LOGIN_URL + username + '&customerCode=')
        .subscribe(data => {
          if (data !== null) {
            if (data['message'].statusCode == APP_Constants.SUCCESS_CODE) {
              this.errorMessage = '';
              this.isLoggedIn = 'true';
              this.isLoading = false;

              // localstorage
              localStorage.setItem('firstOrderListing','true');
              localStorage.setItem('firstEscalationListing','true');
              localStorage.setItem('firstVerificationListing','true');
              localStorage.setItem('firstLocationListing','true');
              localStorage.setItem('isLoggedIn', this.isLoggedIn);
              localStorage.setItem('userData', JSON.stringify(data['userData']));
              localStorage.setItem('menuPages', JSON.stringify(data['userData'].menuPages));   // change it to menupage
              localStorage.setItem('userName', data['userData'].userName);
              localStorage.setItem('firstName', data['userData'].firstName);
              localStorage.setItem('lastName', data['userData'].lastName);
              localStorage.setItem('customerName', data['userData'].customerName);
              localStorage.setItem('lastLogin', data['userData'].lastLogin);
              localStorage.setItem('defaultHomepage', data['userData'].defaultMenu);
              localStorage.setItem('superuser', data['userData'].isSuperUser);
              localStorage.setItem('superuserreadonly', data['userData'].isReadOnlySuperUser);
              localStorage.setItem('readonlyeditownaccess', data['userData'].isEditOwnAccess);
              localStorage.setItem('alwaysUseDHLTheme', data['userData'].alwaysUseDHLTheme);
              localStorage.setItem('customerDropdownColor',  data['userData'].customerCusomizations.SELECTCUSTOMERDROPDOWNCOLOR);
              localStorage.setItem('isMultiLangAvailable', data['userData'].customerCusomizations.ISMULTILANGUAGE)
           
              let imgResp = data['userData'].customerCusomizations,
              logoD = imgResp && imgResp.IMAGE_LOGOD ? imgResp.IMAGE_LOGOD : "",
              logoM = imgResp && imgResp.IMAGE_LOGOM ? imgResp.IMAGE_LOGOM : "",
              logoS = imgResp && imgResp.IMAGE_LOGOS ? imgResp.IMAGE_LOGOS : "";
              localStorage.setItem('logoD', logoD);
              localStorage.setItem('logoM', logoM);
              localStorage.setItem('logoS', logoS);

              let customerCode = '';
              if (data['userData'].preferedCustomerCode) {
                customerCode = data['userData'].preferedCustomerCode;
              } else {
                customerCode = data['userData'].defaultCustomerCode;
              }
              localStorage.setItem('customerCode', customerCode);

              let userRole = '';
              let secondaryUserRoles = '';
              data['userData'].userCustomerSubscriptionList.forEach(element => {
                if (element.customerCode === customerCode) {
                  userRole = element.userRole;
                  secondaryUserRoles = element.secondaryUserRoles;
                  this.preferredUOM = element.preferredUOM;
                  this.userAcessDataRest = element.customerSubscriptionDataRestriction;
                  this.parameterValue = element.parameterValue;
                }
              });

              localStorage.setItem('userRole', userRole);
              localStorage.setItem('preferredUOM',this.preferredUOM);
              localStorage.setItem('secondaryUserRoles', secondaryUserRoles);
              localStorage.setItem('userAcessDataRest', JSON.stringify(this.userAcessDataRest));
              localStorage.setItem('customerList', JSON.stringify(data['userData'].userCustomerSubscriptionList));
              localStorage.setItem('isMultiLangSupport', this.appService.checkMultiLangSupport().toString());
              localStorage.setItem('parameterValue', JSON.stringify(this.parameterValue));

              if(data['userData'].isSuperUser)
                data['userData'].contentPages.push('SUPERUSER');
              
              if (data['userData'].isReadOnlySuperUser)
                data['userData'].contentPages.push('SUPERUSERREADONLY');

              localStorage.setItem('portalSideMenu', JSON.stringify(data['userData'].contentPages));

              this.appService._switchCustomerSubject.next(data['userData'].userCustomerSubscriptionList);
              this.appService._navigationSubject.next(data['userData'].contentPages);

              //CP-3498 - start
              let tokenExpiryTime = parseInt(localStorage.getItem('tokenExpiryTime'));
              // let tokenExpiresIn = (tokenExpiryTime - (5 * 60)) * 1000;
            
              let tokenExpiry = new Date(tokenExpiryTime*1000);
              let currentLocalTime = new Date();

              let expiresIn = (tokenExpiry.getTime() - currentLocalTime.getTime());
              expiresIn = expiresIn - (6 * 60 * 1000);//in milliseconds

              if (expiresIn && expiresIn > 0 && this.appService.refreshCalled == false) {
                this.appService.refreshCalled = true;
                this.appService.refreshToken(expiresIn);
              }
              //cp-3498 -end

              if (data['userData'].defaultMenu) {
                if(environment.showDashboard){
                  this.router.navigateByUrl('/dashboard');
                } else {
                  this.router.navigateByUrl(data['userData'].defaultMenu);
                }
              }
              else
                this.router.navigateByUrl('/profile');

            }
            // check if below code is of any use
            else if (data['message'].statusCode == APP_Constants.ERROR_CODE) {
              this.errorMessage = data['message'].statusMessage;
              this.isLoading = false;

              // Show error message using alert
              // alert('Login Error: ' + this.errorMessage);
              if(environment.isSingleSignOn){
                this.appService.azureLogout();
              }else{
                this.router.navigateByUrl('/logout')
              }
              setTimeout(()=>{
                if(environment.isSingleSignOn){
                  // this.adal.logOut();
                  this.appService.azureLogout();
                }else{
                  this.router.navigateByUrl('/logout')
                }
              }, CommonConfig.AUTO_TIMEOUT);
            }
          }
        },
        err=>{
          this.isLoading = false;
          this.normalView();
          // Show error message using alert
          // alert('Login Error: ' + err.message);
          if(err.status === 401 || err.status === 403 || err.status === 500){
            if(environment.isSingleSignOn){
              this.appService.azureLogout();
            }else{
              this.router.navigateByUrl('/logout');
            }
          }
          setTimeout(()=>{
            if(environment.isSingleSignOn){
              // this.adal.logOut();
              this.appService.azureLogout();
            }else{
              this.router.navigateByUrl('/logout')
            }
          }, CommonConfig.AUTO_TIMEOUT );          
        });       
    }
  }


  login() {
    this.submitted = true;
    let username = this.loginForm.value.username;
    let password = this.loginForm.value.password;
    this.isLoading = true;
    document.getElementById("overlay").style.display = "block";

    if (this.loginForm.invalid) {
      this.normalView();
      this.isLoading = false;
      return;
    }

    this.appService.makeHttpGetRequest(APP_Constants.LOGIN_URL + username + '&customerCode=')
      .subscribe(data => {
        if (data !== null) {
          if (data['message'].statusCode == APP_Constants.SUCCESS_CODE) {
            this.errorMessage = '';
            this.isLoading = false;
            this.normalView();

            // localstorage
            localStorage.setItem('firstOrderListing','true');
            localStorage.setItem('firstEscalationListing','true');
            localStorage.setItem('firstVerificationListing','true');
            localStorage.setItem('firstLocationListing','true');
            localStorage.setItem('isLoggedIn', this.isLoggedIn);
            localStorage.setItem('userData', JSON.stringify(data['userData']));
            localStorage.setItem('menuPages', JSON.stringify(data['userData'].menuPages));
            localStorage.setItem('userName', data['userData'].userName);
            localStorage.setItem('firstName', data['userData'].firstName);
            localStorage.setItem('lastName', data['userData'].lastName);
            localStorage.setItem('customerName', data['userData'].customerName);
            localStorage.setItem('lastLogin', data['userData'].lastLogin);
            localStorage.setItem('defaultHomepage', data['userData'].defaultMenu);
            localStorage.setItem('superuser', data['userData'].isSuperUser);
            localStorage.setItem('superuserreadonly', data['userData'].isReadOnlySuperUser);
            localStorage.setItem('readonlyeditownaccess', data['userData'].isEditOwnAccess);
            localStorage.setItem('alwaysUseDHLTheme', data['userData'].alwaysUseDHLTheme);

            let imgResp = data['userData'].customerCusomizations,
            logoD = imgResp && imgResp.IMAGE_LOGOD ? imgResp.IMAGE_LOGOD : "",
            logoM = imgResp && imgResp.IMAGE_LOGOM ? imgResp.IMAGE_LOGOM : "",
            logoS = imgResp && imgResp.IMAGE_LOGOS ? imgResp.IMAGE_LOGOS : "";
            localStorage.setItem('logoD', logoD);
            localStorage.setItem('logoM', logoM);
            localStorage.setItem('logoS', logoS); 

            let customerCode = '';
            if (data['userData'].preferedCustomerCode) {
              customerCode = data['userData'].preferedCustomerCode;
            } else {
              customerCode = data['userData'].defaultCustomerCode;
            }
            localStorage.setItem('customerCode', customerCode);

            let userRole = '';
            let secondaryUserRoles = '';
            data['userData'].userCustomerSubscriptionList.forEach(element => {
              if (element.customerCode === customerCode) {
                userRole = element.userRole;
                secondaryUserRoles = element.secondaryUserRoles;
                this.preferredUOM = element.preferredUOM;
                this.userAcessDataRest = element.customerSubscriptionDataRestriction;
                this.parameterValue = element.parameterValue;
              }
            });

            localStorage.setItem('userRole', userRole);
            localStorage.setItem('preferredUOM',this.preferredUOM);
            localStorage.setItem('secondaryUserRoles', secondaryUserRoles);
            localStorage.setItem('customerList', JSON.stringify(data['userData'].userCustomerSubscriptionList));
            localStorage.setItem('userAcessDataRest', JSON.stringify(this.userAcessDataRest));
            localStorage.setItem('parameterValue', JSON.stringify(this.parameterValue));

            if (data['userData'].isSuperUser)
              data['userData'].contentPages.push('SUPERUSER');
            
            if (data['userData'].isReadOnlySuperUser)
              data['userData'].contentPages.push('SUPERUSERREADONLY');

            localStorage.setItem('portalSideMenu', JSON.stringify(data['userData'].contentPages));

            this.appService._switchCustomerSubject.next(data['userData'].userCustomerSubscriptionList);
            this.appService._navigationSubject.next(data['userData'].contentPages);

            if (data['userData'].defaultMenu)
              this.router.navigateByUrl(data['userData'].defaultMenu);
            else
              this.router.navigateByUrl('/profile');
          }
          else if (data['message'].statusCode == APP_Constants.ERROR_CODE) {
            this.isLoading = false;
            this.normalView();
            this.errorMessage = data['message'].statusMessage;

            // Show error message using alert
            // alert('Login Error: ' + this.errorMessage);
            if (environment.isSingleSignOn) {
              this.appService.azureLogout();
            } else {
              this.router.navigateByUrl('/logout')
            }
            setTimeout(()=>{
              if(environment.isSingleSignOn){
                // this.adal.logOut();
                this.appService.azureLogout();
              }else{
                this.router.navigateByUrl('/logout')
              }
            }, CommonConfig.AUTO_TIMEOUT);
          }
        }              
      }, err=>{
          console.log(err);
          this.isLoading = false;
          this.normalView();

        // Show error message using alert
        // alert('Login Error: ' + err.message);
        if (err.status === 401 || err.status === 403 || err.status === 500) {
          if (environment.isSingleSignOn) {
            this.appService.azureLogout();
          } else {
            this.router.navigateByUrl('/logout')
          }
        }
        setTimeout(() => {
          if (environment.isSingleSignOn) {
            // this.adal.logOut();
            this.appService.azureLogout();
          } else {
            this.router.navigateByUrl('/logout')
          }
        }, CommonConfig.AUTO_TIMEOUT);
      });
  }  
  fetchAccessToken() {
    let url = window.location.href;
    let urlData = [];
    var azureUrlResponse = {};
    let redirect_uri = '';
    let tokenPayloadString = '';
    let userId = '';
    let id_token = '';
    try {
      urlData = url.split('#')
    } catch (e) {
      urlData = [];
    }
    if (urlData.length) {
      let activeUrl = urlData[1];
      let tokens = [];
      try{
        tokens = activeUrl.split('&');
      } catch(e){
        tokens = [];
      }
      tokens.forEach(data => {
        let jsonData = data.split('=');
        let key = jsonData[0];
        let value = jsonData[1];
        azureUrlResponse[key] = value;
      })
      let tokenDetails = this.appService.getDecodedAccessToken(azureUrlResponse['id_token']);
      if(tokenDetails){
        // userId = tokenDetails.unique_name;
        // let userId = '';
        if(tokenDetails.email){
          userId=tokenDetails.email;
        }else if(tokenDetails.upn){
          userId = tokenDetails.upn;
        }else if(tokenDetails.unique_name){
          userId = tokenDetails.unique_name;
        }
        let code = azureUrlResponse['code'];
        id_token = azureUrlResponse['id_token'];
        this.cookieService.set('id_token', id_token);
        this.alphaService.setRefreshToken(code);
        redirect_uri = window.location.origin + '/login';
        tokenPayloadString = 'username=' + userId + '&code=' + code + '&redirect_uri=' + redirect_uri;
      }
    }

    if (id_token) {
      this.appService.makeHttpPostFormUrlEncoded(APP_Constants.TOKEN_FETCH_URL + userId, tokenPayloadString, id_token).subscribe(response => {
        //localStorage.setItem('tokenData', JSON.stringify(response));
        if (response['message'].statusCode === 'SUCCESS' && response['data']) {
          // localStorage.removeItem('id_token');

          let expiry = (JSON.parse(atob(response['data'].accessToken.split('.')[1]))).exp;
          let tokenExpiry = Math.floor(expiry - (new Date().getTime()/1000)).toString(); 

          // let lastTokenCall = (JSON.parse(atob(response['data'].accessToken.split('.')[1]))).iat;

          localStorage.setItem('tokenExpiry', tokenExpiry);
          localStorage.setItem('tokenExpiryTime', expiry);
          this.cookieService.set('authToken', response['data'].accessToken);
          this.ssoLogin(userId);
        }
      }, err => {
        console.log(err);
      })
    } else {
      this.appService.initiateAzureLogin();
    }
  }

  // refreshToken(expiresIn) {
  //   setTimeout(() => {
  //     console.log('user idle', this.isUserIdle, new Date());
  //     //if(!this.isUserIdle){
  //     if (sessionStorage.getItem("UserIdle10") == 'false') {
  //       this.appService.getRefreshTokenSilently().subscribe(response => {
  //         // implement tokenExpiry feature                          
  //         localStorage.setItem('tokenExpiry', response['data'].expiresIn);
  //         localStorage.setItem('authToken', response['data'].accessToken);

  //         let tokenExpiryTime = parseInt(response['data'].expiresIn);
  //         let tokenExpiresIn = (tokenExpiryTime - (5 * 60)) * 1000;

  //         this.refreshToken(tokenExpiresIn);
  //       }, error => {
  //         console.log(error);
  //       })
  //     }
  //   }, expiresIn);
  // }
}
